import { RestBundle } from './RestBundle';
import { RestHeader } from './RestResource';

export abstract class InjectionBundle extends RestBundle {
	protected readonly headerInjections;

	constructor(...headerInjections: HeaderInjector[]) {
		super();

		this.headerInjections = headerInjections;

		this._options.dynamicHeaders = () => this.dynamicHeaders();
	}

	protected async dynamicHeaders(): Promise<RestHeader> {
		let headers = {};

		for (let injector of this.headerInjections) {
			const injectedHeader = await Promise.race([
				new Promise((_, reject) =>
					setTimeout(() => {
						reject(new Error('Header injector timed out'));
					}, 30000)
				),
				injector.getHeader(),
			]);

			headers = Object.assign(headers, injectedHeader);
		}

		return Promise.resolve(headers);
	}
}

export interface HeaderInjector {
	getHeader(): Promise<RestHeader>;
}
